import { axios } from '@/utils/request'

export const productInfoById = (mallId) => {
  return axios.get(`/api/web/mall/mall/${mallId}`)
}

export const productInfoByCateId = (categoryId) => {
  return axios.get(`/api/web/mall/mall/getModelInfo?categoryId=${categoryId}`)
}
